module.exports = __webpack_public_path__ + "static/media/shoppingActive.ba8a55e2.svg";